<template>
    <div class="dpp-title dpp-title-main">
        <h1 class="singleline">
            <b class="text-bold">{{ dpp.geo.address }}</b><a v-if="dpp.geo.city && !dpp.isRentals" class="hover-dotted" :href="glb.appUrl + dpp.geo.cityPath" :title="`${dpp.geo.city}, ${dpp.geo.state} Homes for Sale`">, {{ dpp.geo.city }}, {{ dpp.geo.state }}</a><template v-else>, {{ dpp.geo.city }}, {{ dpp.geo.state }}</template>
            <a v-if="dpp.geo.zipcode && !dpp.isRentals" class="hover-dotted" :href="glb.appUrl + dpp.geo.zipcodePath" :title="`${dpp.geo.zipcode}, ${dpp.geo.state} Real Estate and Homes for Sale`">{{ dpp.geo.zipcode }}</a>
            <template v-else>{{ dpp.geo.zipcode }}</template>
        </h1>
        <ul class="flex left nowrap">
            <li v-if="dpp.price || dpp.isActive">
                <b class="f3">{{$filters.formatPrice(getPrice)}}</b><abbr title="Monthly Rent" v-if="dpp.isRentals">/Mo</abbr><span class="underdash m-l-1" title="Estimate Vaule" v-if="showEstPrice" v-scroll="'propertyEstimatePanel'" role="button"><i v-if="!hasSoldPrice" class="icon-logo-m-new"></i> Est</span>
            </li>
            <li v-if="!dpp.isLand">
                <b class="f4">{{ dpp.bed ? dpp.bed : '—' }}</b> <abbr title="Bed">{{molang('dpp.dppTitle.bd')}}</abbr>
            </li>
            <li v-if="!dpp.isLand">
                <b class="f4">{{ dpp.bath ? dpp.bath : '—' }}</b> <abbr title="bath">{{molang('dpp.dppTitle.ba')}}</abbr>
            </li>
            <li v-if="dpp.isLand">
                <b class="f4">{{$filters.formatFriendlyLotSize(dpp.lotSize, dpp.lotSizeUnit)}}</b>
            </li>
            <li v-else-if="dpp.area">
                <b class="f4">{{$filters.formatArea(dpp.area, dpp.isLand) }}</b> {{ dpp.areaUnit }}
            </li>
            <li v-if="dpp.pricePerArea && !hidePricePreArea">
                {{$filters.formatPricePerArea(dpp.pricePerArea, dpp.isLand, dpp.isRentals)}}/{{dpp.areaUnit}}
            </li>
        </ul>
        <ul v-if="(getEstimatePriceRange && hasSoldPrice) ||(getMortgagePerMonth && !hideEstMonthCost)" class="flex left nowrap dpp-title-sub">
            <li v-if="getEstimatePriceRange && hasSoldPrice">
                <span @click="showAvmDisclaimer1" class="underdash" role="button"><i class="icon-logo-m-new"></i> Est</span>:
                <span role="button" class="link" v-scroll="'propertyEstimatePanel'">{{getEstimatePriceRange}}</span>
            </li>
            <li v-if="(getMortgagePerMonth && !hideEstMonthCost)">
                <i class="icon-calculator"></i> <template v-if="!glb.isPhone">Mtg:</template> <span class="link" role="button" v-scroll="'propertyMortgagePanel'">{{$filters.formatPrice(getMortgagePerMonth)}}/Mo </span>
                <template v-if="showApproveButton">
                    - <span class="link" @click="showForm(applyObj)" role="button">{{applyObj.cta}}</span>
                </template>
            </li>
        </ul>
        <ul class="flex left nowrap">
            <li v-if="showChangePrice && !dpp.hideDaysOnMarket" >
                <span role="button" :class="{'text-green': dpp.isPriceReduced,'text-red': !dpp.isPriceReduced}" v-scroll="'propertyPriceHistoryPanel'" >
                    <i :class="dpp.isPriceReduced ? 'icon-trend-down' : 'icon-trend-up'"></i> {{$filters.formatFriendlyPrice(dpp.priceChange)}} {{dpp.isPriceReduced ? molang('dpp.dppTitle.drop') : molang('dpp.dppTitle.increase')}}
                </span>
            </li>
            <li v-if="dpp.propertyTypeDisplay" class="hyphenate">
                <i :class="dpp.propertyTypeIcon"></i>
                {{dpp.propertyTypeDisplay}}
            </li>
            <li v-if="subText" data-allow-mismatch="text">
                {{subText}}
            </li>
            <li v-if="dateText" data-allow-mismatch="text">
                {{dateText}}
            </li>
        </ul>
    </div>
</template>
<script src="./dpp-title.js"></script>